import { render, staticRenderFns } from "./PageSlide.vue?vue&type=template&id=3985621e&scoped=true&"
import script from "./PageSlide.vue?vue&type=script&lang=js&"
export * from "./PageSlide.vue?vue&type=script&lang=js&"
import style0 from "./PageSlide.vue?vue&type=style&index=0&id=3985621e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3985621e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3985621e')) {
      api.createRecord('3985621e', component.options)
    } else {
      api.reload('3985621e', component.options)
    }
    module.hot.accept("./PageSlide.vue?vue&type=template&id=3985621e&scoped=true&", function () {
      api.rerender('3985621e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/PageSlide.vue"
export default component.exports